import { render } from "./FlagPT.vue?vue&type=template&id=83c6f6ec"
import script from "./FlagPT.vue?vue&type=script&lang=js"
export * from "./FlagPT.vue?vue&type=script&lang=js"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__